import { createContext, useContext } from 'react';
import { useActor } from '@xstate/react';
export const Context = createContext(undefined);
export const { Provider: PaymentMethodProvider } = Context;
const usePaymentMethodMachine = () => {
    const actorRef = useContext(Context);
    return useActor(actorRef);
};
export default usePaymentMethodMachine;
